<template>
  <!-- 通话信息 -->
  <div class="call-info">
    <div class="title">{{ callType == 'callOut' ? '外呼号码' : '来电号码' }}</div>
    <div class="info">
      <i class="el-icon-phone call-icon"></i>
      <div>
        <span>{{ phoneNum || '未知' }}</span>
        <span>{{ callDuration }}</span>
      </div>
    </div>
    <div class="info" v-if="insertInfo">
      <i class="el-icon-phone call-icon"></i>
      <div>
        <span>{{ insertInfo.serviceNo }}</span>
      </div>
    </div>
    <div class="btn">
      <el-button
        type="primary"
        size="small"
        :disabled="hasHangUp || currOperatorStatus != operatorStatusMap.incall"
        @click="hangUp"
        >挂断</el-button
      >
    </div>
  </div>
</template>

<script>
import { operatorStatusMap } from '../common';
import { hangUpApi } from '@/api/call-system/call-sidebar';

export default {
  name: 'CallInfo',
  props: ['callType', 'phoneNum'],
  data() {
    return {
      operatorStatusMap, // 坐席状态映射
      hasHangUp: false, // 是否已操作过挂断
    };
  },
  computed: {
    /* 坐席当前的状态 */
    currOperatorStatus() {
      return this.$store.state.callSystem.operatorStatus;
    },
    /* 通话时长 */
    callDuration() {
      return this.$store.getters['callSystem/callDuration'];
    },
    /* 强插数据 */
    insertInfo() {
      let currInfo = null;
      let info = this.$store.state.callSystem.insertInfo;
      // 当前坐席属于被强插
      if (info && this.currOperatorDetail.serviceNo != info.serviceNo) {
        currInfo = {
          customerTel: info.customerTel,
          serviceNo: info.toPhone,
        };
      }
      return currInfo;
    },
  },
  methods: {
    async hangUp() {
      await hangUpApi({
        phone: this.phoneNum,
      });
      this.hasHangUp = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.call-info {
  border: solid 1px #dcdfe6;
  padding: 10px;
  width: 100%;
  min-height: 200px;
  box-sizing: border-box;

  .title {
    margin-bottom: 15px;
  }

  .info {
    display: flex;
    align-items: center;
    justify-content: left;

    .call-icon {
      width: 30px;
      font-size: 20px;
    }

    div {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  .btn {
    margin-top: 10px;
    float: right;
  }
}
</style>
